module.exports = __webpack_public_path__ + "img/logo-white.3db73de9.svg";